import { Directive } from '@angular/core';

@Directive({
  selector: 'table[appTable]',
  host: { class: 'app-table' },
})
export class TableDirective {}
